// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute('/$accountId/_user/alarms')({
  component: () => (
    <Suspense>
      <Outlet />
    </Suspense>
  ),
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'glossary:alarms' },
});
